<template>
  <el-card>
    <div slot="header">
      EDI
    </div>
    <el-form
      ref="ediDataForm"
      :model="ediData"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="ILN">
            <el-input
              v-model="ediData.iln"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item>
            <el-checkbox
              v-model="ediData.edi_sync_active"
            >
              EDI szinkron engedélyezve
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-checkbox
              v-model="ediData.edi_test"
            >
              Teszt üzemmód
            </el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
export default {
  props: ['partner'],
  data() {
    return {
      ediData: {
        edi_sync_active: false,
        edi_test: false,
        iln: null
      }
    };
  },
  watch: {
    partner(newVal) {
      if (newVal) {
        this.ediData.edi_sync_active = newVal.edi_sync_active || false;
        this.ediData.edi_test = newVal.edi_test || false;
        this.ediData.iln = newVal.iln || null;
      }
    },
  },
};
</script>
